import { render, staticRenderFns } from "./CreateCase.vue?vue&type=template&id=eac85c6e&scoped=true"
import script from "./CreateCase.vue?vue&type=script&lang=js"
export * from "./CreateCase.vue?vue&type=script&lang=js"
import style0 from "./CreateCase.vue?vue&type=style&index=0&id=eac85c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac85c6e",
  null
  
)

export default component.exports